import * as fromRoot from '../../../store/app.reducers';
import { AccountLoginActions, SET_OPTED_AS_GUEST } from './account-login.actions';
import { ContactProfileState } from '../../../contact-profile/store/contact-profile.reducers';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface AccountLoginState {
    optedAsGuest: boolean;
}

const initialState = {
    optedAsGuest: false
};

export interface State extends fromRoot.AppState {
    accountLogin: AccountLoginState;
}


export function reducer(state = initialState, action: AccountLoginActions) {
    switch (action.type) {
    case SET_OPTED_AS_GUEST:
        return {
            ...state,
            optedAsGuest: action.payload
        };
    default:
        return state;
    }
}

export const getAccountLoginState = createFeatureSelector< AccountLoginState>('accountLogin');

export const getOptedAsGuest = createSelector(
    getAccountLoginState,
    (state: AccountLoginState) => !!state ? state.optedAsGuest : false
);
